import { defineStore } from 'pinia'
import Modal from '@/classes/modals/Modal'

export const useModalStore = defineStore('ModalStore', {
  state: () => ({
    confirm_modal: null
  }),
  actions: {
    postConfirmModal (modal) {
      this.confirm_modal = new Modal(modal)
    },
    deleteConfirmModal () {
      this.confirm_modal = null
    }
  }
})